<template>
  <div class="slider-block">
    <div class="page-container">
      <transition mode="out-in">
        <info-block v-if="slidesArray && !slidesArray[index + 1].infoBlockLeft" class="slider-block__info" :slide="slide"></info-block>
      </transition>
      <background-image class="slider-block__background" :image="isSmall ? slide.image : slide.image2x"></background-image>
      <transition>
        <div class="video-wrapper" v-if="!slide.image">
          <video class="video" ref="video" src="/static/video/sky-video.mp4" autoplay playsinline loop :muted="videoMuted"></video>
          <div class="video-mute-btn" :class="{'muted' : !videoMuted}" @click="toggleAudio"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BackgroundImage from './BackgroundImage.vue'
import InfoBlock from './InfoBlock.vue'
import {mapState} from 'vuex'

export default {
  name:'SliderBlock',
  components: {
    BackgroundImage,
    InfoBlock
  },
  data: () => ({
    videoMuted: true,
  }),
  computed: {
    ...mapState(['slidesArray','slideNumber', 'showGallery', 'videoPopupOpened']),
    isSmall() {
      return window.innerWidth < 1000
    }
  },
  props: {
    index: Number,
    slide: Object
  },
  watch: {
    slideNumber() {
      if (this.slideNumber === 1 && this.$refs.video) {
        this.$refs.video.play();
      } else if (this.$refs.video){
        this.$refs.video.pause();
      }
    },
    showGallery() {
      if (this.showGallery && this.$refs.video) {
        this.$refs.video.pause();
      } else if (this.slideNumber === 1 && this.$refs.video) {
        this.$refs.video.play();
      }
    },
  },
  methods: {
    toggleAudio() {
      if (!this.$refs.video) return
      this.videoMuted = !this.videoMuted;
    }
  },
  mounted() {
    console.log(this.slide)
  }
}
</script>

<style lang="stylus" scoped>
  @import '../styles/tools.styl'
  video
    margin 0
    padding 0
  .video-wrapper
    display flex
    justify-content center
    align-items center
    position absolute
    top 0
    left 0
    height 100vh
    width 100vw
    background-color $backgroundBlue
    transition opacity 1s ease-in-out
    & .video 
      display block
      position absolute
      top 50%
      left 50%
      transform translate3d(-50%, -50%,0)
      min-height 100vh
      min-width 100vw
      margin-left auto
      margin-right auto
      object-fit contain
      object-position 50% 50%

    &.v-leave-to
      opacity 0

  .video-mute-btn
    position absolute
    bottom 40px
    left calc(10vw + 70px)
    width 30px
    height 30px
    background url('../static/images/vol-off.svg') center no-repeat
    background-size contain
    cursor pointer

    &.muted
      background url('../static/images/vol-on.svg') center no-repeat
      background-size contain


  .slider-block
    position relative
    width 100vw
    min-width 100vw
    height 100vh
    box-sizing border-box

    &__info
      display flex
      flex-direction column
      justify-content flex-end
      background-color $backgroundBlue
      height 100%
      width 45%
      margin 0
      padding-right 20px
      padding-left 80px
      padding-bottom 105px
      transition transform .5s ease-in-out
      will-change transform
      &.v-enter
        transform translate3d(-150%,0,0)  
      &.v-leave-to
        transform translate3d(-150%,0,0)  


    &__background
      width 100vw
      height 100%
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      z-index -1

.page-container
  display flex
  flex-direction column
  width 100vw
  height 100vh
  padding-left 10vw
  margin 0
  justify-content flex-end

</style>